export type Hand = number[]
export function isValid(hand: Hand)
{
  return hand.every((v) => ((0 <= v) && (v <= 4)))
}

// Recursively create target hand and compare with current hand.
// Use lower and upper bounds for pruning.
export function calculate(
  hand: Hand, target: Hand,
  targetSize: number,
  setPosition: number,
  upperBound: number,
)
{
  //assertTargetSize(target, targetSize)
  let ret = upperBound
  if (targetSize === 2)
  {
    for (let i = 0; i < 34; ++i)
    {
      target[i] += 2
      // target is fully constructed here.
      if (isValid(target))
      {
        let ub = short(hand, target)
        if (ub < ret)
        ret = ub
      }
      target[i] -= 2
    }
    return ret
  }

  sets.forEach((set, i) =>
  {
    if (i < setPosition) return
    add(target, set)
    if (isValid(target))
    {
      let lb = short(hand, target)
      if (lb < upperBound) // pruning
      {
        // recursion
        let ub = calculate(hand, target, targetSize-3, i, ret)
        if (ub < ret)
        ret = ub
      }
    }
    remove(target, set)
  })
  return ret
}
function add(target: Hand, set: number[])
{
  set.forEach((i) => ++target[i])
}
function remove(target: Hand, set: number[])
{
  set.forEach((i) => --target[i])
}

export function short(hand: Hand, target: Hand)
{
  let ret = 0
  for (let i = 0; i < 34; ++i)
  {
    ret += Math.max(0,
      target[i] - hand[i])
  }
  return ret
}

function seqsOf(suit: number)
{
  if (suit < 3)
  return [...Array(7).keys()].map((_, i) => [
    suit * 9 + i,
    suit * 9 + i + 1,
    suit * 9 + i + 2,
  ])
  return []
}
function tripsOf(suit: number)
{
  if (suit < 3)
  return [...Array(9).keys()].map((_, i) => [
    suit * 9 + i,
    suit * 9 + i,
    suit * 9 + i,
  ])
  return [...Array(7).keys()].map((_, i) => [
    suit * 9 + i,
    suit * 9 + i,
    suit * 9 + i,
  ])
}
const sets = [
  ...seqsOf(0),
  ...seqsOf(1),
  ...seqsOf(2),
  ...tripsOf(0),
  ...tripsOf(1),
  ...tripsOf(2),
  ...tripsOf(3),
]

// adopted from: https://gist.github.com/gimite/6249634#file-shanten_analysis-js
